export default {
    BASE_URL: process.env.REACT_APP_SERVER_URL,

    // auth
    LOGIN_URL: '/api/internal/auth/admin/login',
    CHANGE_PASSWORD_URL: '/api/internal/auth/change-password',
    FORGOT_PASSWORD_URL: '/api/internal/auth/forgot-password',
    RESET_PASSWORD_URL: '/api/internal/auth/reset-password',

    FETCH_ME_URL: '/api/internal/admin/me',
    ADMIN_URL: '/api/internal/admin',

    REPORT_COURTS: '/api/internal/admin/report_courts',
    SYSMANAGE_URL: '/api/internal/system-setting',

    //admin
    GET_DASHBOARDDATA_URL: '/api/internal/admin/dash_summary',

    CLUB_URL: '/api/internal/club',
    ADMIN_CLUB_URL: '/api/internal/admin/clubs',

    ACCEPT_CLUBRSSERVICE_URL: '/api/internal/admin/accept-clubrsservice',
    REJECT_CLUBRSSERVICE_URL: '/api/internal/admin/reject-clubrsservice',
    CONTROL_CLUBFEATURE_URL: '/api/internal/admin/control-clubfeature',

    UPDATE_CLUBSETTINGS_URL: '/api/internal/clubsetting/update',
    GET_DBBACKUPFILES_URL: '/api/internal/admin/get_dbbackup_files',
    RESTORE_DB_URL: '/api/internal/admin/restore_db',
    BACKUP_DB_URL: '/api/internal/admin/backup_db',
    DOWNLOAD_BACKUPFILE_URL: '/api/internal/admin/download_backupfile',
    UPLOAD_BACKUPFILE_URL: '/api/internal/admin/upload_backupfile',

    SEARCH_REPORTS_URL: '/api/internal/report/search',
    GET_REPORT_URL: '/api/internal/report',
    RESOLVE_REPORT_URL: '/api/internal/report/resolve',

    RETRIEVE_MEMBER_URL: '/api/internal/user/search',
    CREATE_MEMBER_URL: '/api/internal/user/signup',
    UPDATE_MEMBER_URL: '/api/internal/user/update',
    READ_MEMBER_URL: '/api/internal/user',

    INVOICE_URL: '/api/internal/invoice',
    CMTY_EVENT_URL: '/api/internal/cmtyevent',

    PAYMENT_FEESETTING_URL: '/api/internal/paymentfee-setting',

    UPLOAD_FILE_URL: '/api/internal/upload/general',

    DEVELOPER_URL: '/api/internal/developer',

    SEARCH_CLUBEVENT_URL: '/api/internal/clubevent/search',

    PARTNER_URL: '/api/internal/partners',
    ADMIN_PARTNER_URL: '/api/internal/admin/partners',
};
